import React from "react";
import BetWindow from "./components/BetWindow"
import Graph from "./components/Graph"
import ICPPayoutBanner from "./components/ICPPayoutBanner"
import Navbar from './components/Navbar'
import Footer from './components/Footer'

import { useLocation } from 'react-router-dom';
import { useState, useEffect, Fragment } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { XMarkIcon, MegaphoneIcon } from '@heroicons/react/24/outline'

import { RadioGroup } from '@headlessui/react'
import { CheckCircleIcon } from '@heroicons/react/20/solid'

import { fetchFixtures } from '../API/football'
import { HomeIcon } from '@heroicons/react/20/solid';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function Game({ principal, setPrincipal }) {

  // const [worldcupFixtures, setWorldcupFixtures] = useState([]);

  // useEffect(() => {
  //   fetchFixtures(1, 2022).then(data => {
  //     setWorldcupFixtures(data)
  //   })
  // }, [])

  const game = useLocation()

  let home = game.state.home
  let away = game.state.away
  let homeLogo = game.state.homeLogo
  let awayLogo = game.state.awayLogo
  let date = game.state.date
  let time = game.state.time
  let stadium = game.state.stadium
  const markets = [home, 'DRAW', away]
  const [market, setMarket] = useState(markets[0])
  const books = [home + away, 'DRAW']
  var [book, setBook] = useState(books[0])


  function selectBook(market, home, away) {
    if (market === 'DRAW') {
      book = 'DRAW'
    }
    else {
      book = home + away
    }
    return book
  }

  const [open, setOpen] = useState(false)


  if (window.innerWidth < 1024) {
    return (
      <div>
        <header
          className="sticky top-0 z-50" >
          < Navbar principal={principal} setPrincipal={setPrincipal} />
        </header>
        <div className="mx-auto max-w-7xl px-2">
          <div className="pt-5">
            <div>
              <div>
                <div className="px-4 pb-4 grid cols-3">
                  <li className="rounded-lg bg-gray-100 shadow">
                    <div className="flex">
                      <div className="flex w-0 flex-1 pt-1">
                        <a className="relative -mr-px inline-flex w-0 flex-1 items-center justify-center rounded-bl-lg border border-transparent  text-3xl font-bold text-gray-600 hover:text-purple-600">
                          <img
                            className="h-10 w-14"
                            src={homeLogo}
                            alt="Logo"
                          />
                        </a>
                        <h1 className="flex text-3xl font-bold text-center text-gray-600 hover:text-purple-600 tracking-tight">
                          V
                        </h1>
                        <div className="-ml-px flex w-0 flex-1">
                          <a className="relative inline-flex w-0 flex-1 items-center justify-center rounded-br-lg border border-transparent  text-3xl font-bold text-gray-600 hover:text-purple-600">
                            <img
                              className="h-10 w-14"
                              src={awayLogo}
                              alt="Logo"
                            />
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="flex w-full items-center justify-center space-x-4">
                      <div className="flex items-center space-x-2">
                        <h3 className="truncate text-sm font-medium text-gray-900">
                          {date}
                        </h3>
                        <span className="inline-block flex-shrink-0 rounded-full bg-green-100 px-2 text-xs font-medium text-green-800">
                          {time}
                        </span>
                      </div>
                    </div>
                    <div className="flex w-full items-center justify-center space-x-6">
                      <p className="mt-1 truncate text-sm text-gray-500">
                        {stadium}
                      </p>
                    </div>
                    <div className="justify-center px-4">
                      <RadioGroup value={market} onChange={setMarket}>
                        <div className="p-1 grid grid-cols-3 gap-2 ">
                          {markets.map((markets) => (
                            <RadioGroup.Option
                              key={markets}
                              value={markets}
                              className={({ checked, active }) =>
                                classNames(
                                  checked ? 'border-transparent bg-gradient-to-br from-purple-600 to-orange-300' : 'border-gray-300',
                                  active ? 'ring-2 ring-black' : '',
                                  'relative flex cursor-pointer rounded-lg border bg-white p-3 shadow-sm focus:outline-none'
                                )
                              }
                            >
                              {({ checked, active }) => (
                                <>
                                  <span className="flex flex-1">
                                    <span className="flex flex-col">
                                      <RadioGroup.Label as="span" className="block text-sm  text-gray-900 font-bold">
                                        {markets}
                                      </RadioGroup.Label>
                                    </span>
                                  </span>
                                  {checked ? <CheckCircleIcon className="h-5 w-5 text-black" aria-hidden="true" /> : null}
                                  <span
                                    className={classNames(
                                      active ? 'border' : 'border-2',
                                      checked ? 'border-black' : 'border-transparent',
                                      'pointer-events-none absolute -inset-px rounded-lg'
                                    )}
                                    aria-hidden="true"
                                  />
                                </>
                              )}
                            </RadioGroup.Option>
                          ))}
                        </div>
                      </RadioGroup>
                    </div>
                  </li>
                </div>
              </div>
              <div >
                <Graph />
              </div>
              <div>
                <div className="grid px-20 pt-4">
                  <button
                    type="button"
                    className="text-3xl rounded-lg bg-white bg-opacity-70 hover:bg-gray-100 text-black"
                    onClick={() => setOpen(true)}
                  ><div className="gradient-border" id="box">BET</div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Transition.Root show={open} as={Fragment}>
          <Dialog as="div" className="relative" onClose={setOpen}>
            <div className="">
              <div className="inset-0 fixed overflow-y-scroll">
                <div className="pointer-events-none py-20 flex pl-20">
                  <Transition.Child
                    as={Fragment}
                    enter="transform transition ease-in-out duration-500"
                    enterFrom="translate-x-full"
                    enterTo="translate-x-0"
                    leave="transform transition ease-in-out duration-500"
                    leaveFrom="translate-x-0"
                    leaveTo="translate-x-full"
                  >
                    <Dialog.Panel className="pointer-events-auto w-screen max-w-md">
                      <div className="flex flex-col divide-y w-screen inset-0 max-w-md divide-gray-200 bg-white rounded shadow-xl">
                        <div className="h-0 flex-1 inset-0">
                          <div>
                            <div className="grid grid-cols-7 pt-1 flex-wrap items-center">
                              <span className="flex rounded-lg justify-center">
                                <MegaphoneIcon className="h-6 w-6 text-black" aria-hidden="true" />
                              </span>
                              <div className="col-span-5 text-center">
                                <p className="truncate font-medium text-black text-center">1 Contract is worth 1 ICP</p>
                              </div>
                              <div className="flex justify-center">
                                <button
                                  type="button"
                                  className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                                  onClick={() => setOpen(false)}
                                >
                                  <span className="sr-only">Close panel</span>
                                  <XMarkIcon className="h-8 w-8" aria-hidden="true" />
                                </button>
                              </div>
                            </div>
                            <div className="py-2">
                              <BetWindow principal={principal} gameID={game.state._id} market={market} book={selectBook(market, home, away)} home={home} away={away} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </Dialog.Panel>
                  </Transition.Child>
                </div>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
        <footer className="fixed bottom-0 w-full z-50">
          < Footer />
        </footer>
      </div>
    )
  }

  else {
    return (
      <div>
        <header
          className="sticky top-0 z-50" >
          < Navbar principal={principal} setPrincipal={setPrincipal} />
        </header>
        <div className="mx-auto max-w-7xl px-2 sm:px-4 lg:px-8">
          <div className="flex lg:grid lg:grid-cols-12 py-5 lg:gap-x-8">
            <div className="flex-auto lg:col-span-7 xl:col-span-7">
              <div>
                <div className="px-4 sm:px-6 lg:px-8 pb-4">
                  <li className="col-span-1 rounded-lg bg-gray-100 shadow">
                    <div>
                      <div className="-mt-px flex">
                        <div className="flex w-0 flex-1">
                          <a className="relative -mr-px inline-flex w-0 flex-1 items-center justify-center rounded-bl-lg border border-transparent  text-3xl font-bold text-gray-600 hover:text-purple-600">
                            <img
                              className="h-16 w-24"
                              src={homeLogo}
                              alt="Logo"
                            />
                          </a>
                        </div>
                        <div className="justify-center flex w-0 flex-1">
                          <a className="relative inline-flex w-0 flex-1 items-center justify-center rounded-br-lg border border-transparent  text-3xl font-bold text-gray-600 hover:text-purple-600">
                            <h1 className="text-4xl font-bold text-center text-gray-600 hover:text-purple-600 tracking-tight">
                              V
                            </h1>
                          </a>
                        </div>
                        <div className="-ml-px flex w-0 flex-1">
                          <a className="relative inline-flex w-0 flex-1 items-center justify-center rounded-br-lg border border-transparent  text-3xl font-bold text-gray-600 hover:text-purple-600">
                            <img
                              className="h-16 w-24"
                              src={awayLogo}
                              alt="Logo"
                            />
                          </a>
                        </div>
                        <div className="mx-auto  flex-shrink-0 flex items-center justify-center">
                          <a>

                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="flex w-full items-center justify-center space-x-6 p-1">
                      <div className="flex items-center space-x-3">
                        <h3 className="truncate text-sm font-medium text-gray-900">
                          {date}
                        </h3>
                        <span className="inline-block flex-shrink-0 rounded-full bg-green-100 px-2 py-0.5 text-xs font-medium text-green-800">
                          {time}
                        </span>
                      </div>
                    </div>
                    <div className="flex w-full items-center justify-center space-x-6 p-1">
                      <p className="mt-1 truncate text-sm text-gray-500">
                        {stadium}
                      </p>
                    </div>
                    <div className="justify-center px-12">
                      <RadioGroup value={market} onChange={setMarket}>
                        <div className="p-2 grid grid-cols-3 sm:gap-8 lg:gap-24 ">
                          {markets.map((markets) => (
                            <RadioGroup.Option
                              key={markets}
                              value={markets}
                              className={({ checked, active }) =>
                                classNames(
                                  checked ? 'border-transparent bg-gradient-to-br from-purple-600 to-orange-300' : 'border-gray-300',
                                  active ? 'ring-2 ring-black' : '',
                                  'relative flex cursor-pointer rounded-lg border bg-white p-4 shadow-sm focus:outline-none'
                                )
                              }
                            >
                              {({ checked, active }) => (
                                <>
                                  <span className="flex flex-1">
                                    <span className="flex flex-col">
                                      <RadioGroup.Label as="span" className="block text-sm  text-gray-900 font-bold">
                                        {markets}
                                      </RadioGroup.Label>
                                    </span>
                                  </span>
                                  {checked ? <CheckCircleIcon className="h-5 w-5 text-black" aria-hidden="true" /> : null}
                                  <span
                                    className={classNames(
                                      active ? 'border' : 'border-2',
                                      checked ? 'border-black' : 'border-transparent',
                                      'pointer-events-none absolute -inset-px rounded-lg'
                                    )}
                                    aria-hidden="true"
                                  />
                                </>
                              )}
                            </RadioGroup.Option>
                          ))}
                        </div>
                      </RadioGroup>
                    </div>
                  </li>
                </div>
              </div>
              <div >
                <Graph />
              </div>
            </div>
            <div className="mt-6 lg:col-span-5 lg:mt-0 xl:col-span-5">
              <div>
                <ICPPayoutBanner />
              </div>
              <div className="py-2">
                <BetWindow principal={principal} gameID={game.state._id} market={market} book={selectBook(market, home, away)} home={home} away={away} />
              </div>
            </div>
          </div>
        </div>
        <footer className="fixed bottom-0 w-full z-50">
          < Footer />
        </footer>
      </div>

    );
  }

}
